import clsx from 'clsx';
import React from 'react';
import LoaderEye from 'components/shared/LoaderEye/LoaderEye';
import 'swiper/css';
import CategorySelector from './CategorySelector';
import styles from './Feed.module.scss';

export interface INoContent {
  feedData?: any
  setFeedGroup: (feedGroup: string) => void;
  isLoading?: boolean
}

function NoContentFound({
  feedData, setFeedGroup, isLoading,
}: INoContent) {
  return (
    <div className={styles.container}>
      <div className={styles.posts}>
        <div className={styles.postContainer}>
          <div className={styles.panel}>
            <div className={styles.panelInner}>
              <div className={clsx(
                styles.panelSection,
                styles.panelSection_placeholder,
                !(feedData?.isLoading || isLoading) && styles.panelSection_noBg,
              )}
              >
                {feedData?.isLoading || isLoading ? (
                  <LoaderEye className={styles.loader} />
                ) : (
                  <p className={styles.nothingFound}>Nothing found</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NoContentFound;
